<template>
  <div :class="{'page--container': !layout }">
    <div :class="{'page--section': !layout }">
      <el-row :gutter="30">
        <el-col
          :sm="sm"
          v-for="video in videos"
          :key="video.id">
          <media-video-excerpt
            :video="video">
          </media-video-excerpt>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import MediaVideoExcerpt from '@/components/media/MediaVideoExcerpt.vue';

  export default {
    name  : 'TrainingVideosListing',
    props : {
      'videos' : {},
      'sm'     : {
        default : 24,
      },
      layout : {
          type      : Boolean,
          required  : false,
          default   : false,
      },
    },
    components : {
      MediaVideoExcerpt,
    },
  };
</script>

<style lang="scss" scoped>
</style>
